<script lang="ts">
  import Icon from "@/lib/components/icon/icon.svelte";
  import GenericCompletion from "@/lib/components/generic-completion/generic-completion.svelte";
</script>

<GenericCompletion type="shorten">
  <svelte:fragment slot="header">
    <Icon name="text-minus" class="block size-20" />
    Make Shorter
  </svelte:fragment>
  <svelte:fragment slot="hint">
    Trim down the text in the message.
  </svelte:fragment>
</GenericCompletion>
